import * as React from "react";
import type { SVGProps } from "react";

interface PuntProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Punt = ({ cancelled = false, ...props }: PuntProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFF"
        d="M5 1.25A2.75 2.75 0 0 1 6.51 6.3 2.75 2.75 0 0 1 8.75 9v7c0 .41-.34.75-.75.75H2a.75.75 0 0 1-.75-.75V9c0-1.34.96-2.46 2.24-2.7A2.75 2.75 0 0 1 5 1.25M6 7H4a2 2 0 0 0-2 2v7h6V9a2 2 0 0 0-2-2M5 2a2 2 0 1 0 0 4h.15A2 2 0 0 0 5 2"
      />
      <path
        fill="#000"
        d="M6 7a2 2 0 0 1 2 2v7H2V9c0-1.1.9-2 2-2zM5 2a2 2 0 0 1 .15 4H5a2 2 0 0 1-.15-4z"
      />
      <path
        fill="#007BBD"
        d="M6 8H4a1 1 0 0 0-1 1v6h4V9a1 1 0 0 0-.88-1zM5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
      <path
        fill="#FFF"
        d="M12 1.25a2.75 2.75 0 0 1 1.51 5.05A2.75 2.75 0 0 1 15.75 9v7c0 .41-.34.75-.75.75H9a.75.75 0 0 1-.75-.75V9c0-1.34.96-2.46 2.24-2.7A2.75 2.75 0 0 1 12 1.25M13 7h-2a2 2 0 0 0-2 2v7h6V9a2 2 0 0 0-2-2m-1-5a2 2 0 1 0 0 4h.15A2 2 0 0 0 12 2"
      />
      <path
        fill="#000"
        d="M13 7a2 2 0 0 1 2 2v7H9V9c0-1.1.9-2 2-2zm-1-5a2 2 0 0 1 .15 4H12a2 2 0 0 1-.15-4z"
      />
      <path
        fill="#007BBD"
        d="M13 8h-2a1 1 0 0 0-1 1v6h4V9a1 1 0 0 0-.88-1zm-1-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
      <path
        fill="#FFF"
        d="M19 16.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m0 .75a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
      />
      <path fill="#000" d="M19 17a3 3 0 1 1 0 6 3 3 0 0 1 0-6" />
      <path fill="#C5C5C5" d="M19 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
      <path
        fill="#000"
        stroke="#FFF"
        strokeWidth={0.75}
        d="M19.65 6.91a.87.87 0 0 1 .67.09c.58.85.42 1.02.32 1.19-.1.2-.3.35-.53.4a7.56 7.56 0 0 1 2.24 3.27c.48 1.53.47 2.9-.03 4.1a.87.87 0 0 1-1.62 0 .87.87 0 0 1 0-.67c.35-.82.33-1.78-.02-2.9a5.03 5.03 0 0 0-1.65-2.3.87.87 0 0 1-.64.97c-.34.04-.57-.03-.74-.15a.83.83 0 0 1-.36-.62l-.16-1.95a.87.87 0 0 1 .64-.92Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Punt;
